'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducers;
exports.getHeadline = getHeadline;
var t = {
    GET_HEADLINE: '/home/GET_HEADLINE',
    GET_HEADLINE_SUCCESS: '/home/GET_HEADLINE_SUCCESS',
    GET_HEADLINE_FAIL: '/home/GET_HEADLINE_FAIL'
};

var initialState = {
    headline: []
};

function reducers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case t.GET_HEADLINE_SUCCESS:
            return _extends({}, state, {
                headline: action.result.data.data
            });
        default:
            return state;
    }
}

function getHeadline() {
    return {
        types: [t.GET_HEADLINE, t.GET_HEADLINE_SUCCESS, t.GET_HEADLINE_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/bp/home/rolling_news');
            }

            return promise;
        }()
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/home/home.js
// module id = 501
// module chunks = 0